import React from 'react';
import "../CasinoGameView.scss";
import "./BlinkCasinoGameView.scss";



import {connect} from "react-redux";
import {Dispatch} from "redux";
import {addPlayedGame, loadCasinoGames, toggleFavouriteGame} from "../../../CasinoActions";
import { CasinoStatus} from "../../../CasinoReducer";
import {AppState} from "../../../../RootReducer";
import {RouteComponentProps, withRouter} from "react-router-dom";
import {
    CasinoGameInfo,
    CasinoGameInfo as CasinoGame,
    CasinoPage,
    CasinoPageTab,
    CasinoStudio,
    CurrencyDefinition,
    Exchange,
    GameDisplay,
    LaunchCasinoGameResponse,
    Settings,
    CasinoMobileNavigation
} from "../../../../http/protocol";
import {getContainer} from "../../../../ioc/IOCSetup";
import {setShowBalance} from "../../../../user/UserActions";
import {t} from "../../../../i18n";
import CasinoGameThumbnail, {launchMobile} from "../../CasinoGameThumbnail";
import Translator from "../../../../Translator";
import MetaHelmet from "../../../../utils/MetaHelmet";
import {
    getFavouritesBySelectedPage,
    getSelectedPage,
    getSelectedPageTab,
    getStudios
} from "../../../../selectors/casino-selectors";
import {goToLobby, isBot, toSEOFriendlyString} from "../../../../user/ui/utils";
import {addToast} from '../../../../toasts/toasts';
import CurrencyFormatter from '../../../../utils/CurrencyFormatter';
import {getCurrencyDefinitionByCode} from '../../../../selectors/settings-selectors';
import ProfileMetamapComponent from '../../../../profilepage/ProfileMetamapComponent';
import {PATH} from '../../../../onboardingpage/modalview/UserModalController';
import {setModalPath} from '../../../../onboardingpage/modalview/utils';
import  BlinkCasinoGameComponent  from './BlinkGameComponent';
import { showSideMenu } from "../../../../navigation/NavigationActions";

const CloseButton = () => (
    <svg version="1.1" pointerEvents="bounding-box" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"

         width="20px" height="20px" viewBox="-36.5 91.5 648.5 684.99" >
        <polygon fill="#FFFFFF" points="356.28,433.98 599.55,167.05 611.11,154.38 599,142.22 562.78,105.85 549.45,92.47 536.72,106.43
                                            287.76,379.61 38.77,106.43 26.04,92.46 12.71,105.86 -23.51,142.26 -35.61,154.41 -24.06,167.08 219.22,434.01 -24.05,700.94
                                            -35.61,713.61 -23.5,725.76 12.72,762.13 26.05,775.52 38.78,761.56 287.74,488.38 536.73,761.56 549.46,775.53 562.79,762.13
                                            599.01,725.73 611.11,713.58 599.56,700.91 "/>

    </svg>
);

type AllProps = Props & RouteComponentProps<{ mode? : string, gameId :string, name : string}>;

export enum LaunchMode  {
    real = "real",
    fun = "fun",
    auto = "auto"
}
export enum GameMode {
    PLAY_FOR_REAL,
    PLAY_FOR_FUN,
    LOGIN_TO_PLAY_FOR_REAL
}
interface Props {
    status? : CasinoStatus;
    game?: CasinoGame;
    loadCasinoGames?: () => void
    setShowBalance?: (show: boolean) => void
    match?: any;
    gameId?: string;
    currencyCode?: string;
    windowSize: number;
    addPlayedGame : (id : CasinoGameInfo, pageId? : number) => void;
    searchValue? : string;
    favourite?: boolean;
    toggleFavourite? : (game? : CasinoGameInfo, pageId? : number)=>void;
    settings? : Settings;
    loggedIn?: boolean;
    isMobile?: boolean;
    studios? : CasinoStudio[];
    selectedTab?: CasinoPageTab;
    selectedPage?: CasinoPage;
    currencyDefinition?: CurrencyDefinition;
    userModal: {verification: boolean, newUser: boolean},
    showBalance? : boolean;
    hideSideMenu? : () => void;
}
interface State {
    width: number;
    height: number;
    gameWidth: number;
    gameHeight: number;
    gameUrl?: string;
    fullscreen?: boolean;
    status? : LaunchUrlStatus;
    countryBlocked?: boolean;
    bonusBlocked?: boolean;
    kycBlocked?: boolean;
    currencyNotSupported?: boolean;
    loading:boolean;
    exchange?: Exchange;
    gameDisplay?:string;
    playForFun?:boolean;
    mobileNavigation: boolean;
    originals?:boolean;
}
enum LaunchUrlStatus {
    NONE, IN_PROGRESS, SUCCESS, ERROR
}
export class BlinkCasinoGameView extends React.Component<AllProps, State>{
    constructor(props : AllProps) {
        super(props);
        const playForFun = this.props.location.state && (this.props.location.state as any).playForFun ?( this.props.location.state as any).playForFun : false;

        this.state = {  loading:true, width: 0, height: 0, gameWidth: 0, gameHeight: 0, fullscreen: this.props.isMobile, status : LaunchUrlStatus.NONE, countryBlocked : false,
            kycBlocked: false, currencyNotSupported : false,  gameDisplay: "", playForFun:playForFun, mobileNavigation: false,originals:false }
    }

    getRequestedMode() {
        return this.getGameModeFromProps(this.props);
    }
    getRequestedModeFromProps(props : AllProps) : string {
        let mode : LaunchMode = LaunchMode[props.match.params.mode as keyof typeof LaunchMode];
        return mode ? mode : LaunchMode.real;
    }
    getGameMode() {
        return this.getGameModeFromProps(this.props)
    }
    getPreviousGameMode(prevProps : Readonly<AllProps>) {
        return this.getGameModeFromProps(prevProps);
    }
    getGameModeFromProps (props : AllProps) {
        let mode = this.getRequestedModeFromProps(props);
        if(mode == LaunchMode.real) {
            if(props.loggedIn) {
                return GameMode.PLAY_FOR_REAL;
            } else {
                return GameMode.LOGIN_TO_PLAY_FOR_REAL;
            }
        } else if(mode == LaunchMode.fun) {
            if(props.game && props.game.playForFun) {
                return GameMode.PLAY_FOR_FUN;
            } else {
                return GameMode.LOGIN_TO_PLAY_FOR_REAL;
            }
        } else if(mode == LaunchMode.auto) {
            if(props.loggedIn) {
                return GameMode.PLAY_FOR_REAL;
            } else if(isBot(navigator.userAgent)) {
                return GameMode.LOGIN_TO_PLAY_FOR_REAL;
            } else if (props.game && props.game.playForFun) {
                return GameMode.PLAY_FOR_FUN;
            } else {
                return GameMode.LOGIN_TO_PLAY_FOR_REAL;
            }
        }

    }


    componentDidMount(): void {
     
        document.body.classList.add("playing-casino-game");
        document.querySelector("html")?.classList.add("playing-casino-game")
        if(this.props.status != CasinoStatus.DONE) {
            this.props.loadCasinoGames && this.props.loadCasinoGames();

        }

        if(localStorage.getItem("menustate") === "on") {
            this.props.hideSideMenu && this.props.hideSideMenu();
        }
        window.addEventListener("orientationchange ", (e) => {
            console.log("orientationchange event : ", e)
        })


        window.addEventListener("message", (e)=>{
            if(e.data.action == "exitCasinoGame") {
                this.props.history.push("/casino");
            }
        })


        if(this.props.game && (this.props.currencyCode || this.getGameMode() == GameMode.PLAY_FOR_FUN)) {
            this.initGame(this.props.game, this.props.currencyCode);
        }

    }
    toggleGameMode = () => {
        let mode = this.getGameMode();
        if(mode === GameMode.PLAY_FOR_REAL) {
            launchMobile(this.props.game, true, this.props.history);
        } else {
            launchMobile(this.props.game, false, this.props.history);
        }
  
    }
   

    initGame(game : CasinoGame, currencyCode? : string) {
        if(game.id) {
            this.props.addPlayedGame(game, this.props.selectedPage?.id);
        }
    
        this.fetchLaunchUrl(currencyCode);
    }

    fetchLaunchUrl(currencyCode? : string) {
        if(this.getGameMode() == GameMode.PLAY_FOR_FUN) {
            this.setState({ gameUrl : undefined, status : LaunchUrlStatus.IN_PROGRESS});
            getContainer().getCasinoService().getDemoGameLaunchUrl(""+this.props.gameId, getContainer().getSettingsService().getActiveLocale().code, this.props.isMobile).then((launch : LaunchCasinoGameResponse)=>{
                this.setState({gameUrl : launch.url, status : LaunchUrlStatus.SUCCESS, countryBlocked : launch.countryBlock,  exchange:launch.exchange, gameDisplay:this.props.game && this.props.game.display || ""});
            }).catch(()=>{
                this.setState({ status : LaunchUrlStatus.ERROR})
            });
        } else if(this.getGameMode() == GameMode.PLAY_FOR_REAL && currencyCode) {

        this.setState({ gameUrl : undefined, status : LaunchUrlStatus.IN_PROGRESS});
            getContainer().getCasinoService().getGameLaunchUrl(""+this.props.gameId, currencyCode, this.props.isMobile, getContainer().getSettingsService().getActiveLocale().code).then((launch : LaunchCasinoGameResponse)=>{
              this.setState({
                    gameUrl : launch.url,
                    status : LaunchUrlStatus.SUCCESS,
                    countryBlocked : launch.countryBlock,
                    currencyNotSupported: launch.currencyNotSupported,
                    bonusBlocked: launch.bonusContext?.blockedFromPlaying,
                    kycBlocked: launch.kycRequired,
                    exchange:launch.exchange,
                    gameDisplay: this.props.game && this.props.game.display || "",
                    originals:launch && launch?.originals
                });

                const bc = launch.bonusContext;
                if (bc  &&  !bc.blockedFromPlaying  &&  bc.maxWager != undefined  &&  bc.contributionFactor != undefined) {
                    const contribPercent = ((bc.contributionFactor ?? 0) * 100).toFixed(0);
                    const maxStake = CurrencyFormatter.formatWithSymbol(this.props.currencyDefinition, bc.maxWager);
                    addToast(() => {}, t("bonus.bonusGameToast.title", {gameName: this.props.game?.name}), t("bonus.bonusGameToast.message", {contribPercent: contribPercent, maxStake: maxStake}), undefined, 5000)
                }
            }).catch(()=>{
                this.setState({ status : LaunchUrlStatus.ERROR})
            });
  
          
        }

    }

    hasGameModeChanged(prevProps : Readonly<AllProps>) {
        return this.getGameMode() != this.getGameModeFromProps(prevProps);
    }
    hasGameChanged(game : CasinoGame, prevGame? : CasinoGame) {
        if(!prevGame) {
            return true;
        }
        return game.id != prevGame.id;
    }
    componentDidUpdate(prevProps: Readonly<AllProps>, prevState: Readonly<State>, snapshot?: any): void {
        if(!this.state.gameUrl) {
            if(this.props.gameId && this.props.currencyCode && this.props.showBalance == true) {
                this.props.setShowBalance && this.props.setShowBalance(false);
            }
        }
        let initGameRequired = false;
        let game = this.props.game;
        if(!game || !this.props.currencyCode)  {
            initGameRequired = false; // game has not loaded yet

        } else if (this.props.loggedIn && !prevProps.loggedIn) {
            // User just logged in - initialize game
            initGameRequired = true;
            this.setState({ originals: false });
            console.log('Initializing game after login');
        } else if (this.props.loggedIn && this.props.currencyCode !== prevProps.currencyCode && prevProps.currencyCode === '') {
            // Currency changed while logged in - don't initialize
            initGameRequired = true;
            console.log('Currency changed while logged in - skipping init');
        } else  if(this.hasGameModeChanged(prevProps)) {
            initGameRequired = true;

        } else if(game && this.hasGameChanged(game, prevProps.game)) {
            initGameRequired = true
        }

        if(initGameRequired && game && (this.props.currencyCode)) {
            this.initGame(game, this.props.currencyCode);
        }

        if(game && game.display !== GameDisplay.EMBEDDED){
            this.toggleGameMode();
        }
   
        //@ts-ignore
        if(window.fcWidget) {
            //@ts-ignore
            window.fcWidget.hide();
        }
    }

    componentWillUnmount() {
        const menuContent = document.body.querySelector('.menu-layout-content');
        if (menuContent) {
            menuContent.classList.remove('game-inview');
        }
        document.body.classList.remove("playing-casino-game");
        document.querySelector("html")?.classList.remove("playing-casino-game")
        this.props.setShowBalance&& this.props.setShowBalance(true);

        //@ts-ignore
        if(window.fcWidget) {
            //@ts-ignore
            window.fcWidget.show();
        }
    }


  
    close() {
       goToLobby(this.props.history, this.props.selectedPage, this.props.selectedTab);
    }


    getMetaHelmet() {
        let game = this.props.game;
        if(game) {
            let subtitle:string = game.name || "";
            let description:string = this.props.game && this.props.game.description || t("meta.casino.games.play", {gameName: subtitle, brandName:this.props.settings?.operatorName, interpolation: { escapeValue: false }}) || "";
            let keywords:string = `${game.name}, ${game.gameType}, ${this.props.studios?.find(s => s.id == game?.studioId)?.name}, ${game.playForFun ? "Play for Fun" : ""}`
            return <MetaHelmet title={`${game.name} | ${this.props.settings?.operatorName}`} description={description} keywords={keywords} ogTitle={`${game.name} | ${this.props.settings?.operatorName}`} ogDescription={description} ogImage={game.imageUrl} />;
        }
        return <div/>

    }
 

    render() {


        if(this.props.status == CasinoStatus.NONE || this.props.status == CasinoStatus.LOADING || this.state.status == LaunchUrlStatus.IN_PROGRESS) {
            return (
                <div id="jsLoader" className="js-loader">
                <img src="/preloader.png" id="site-loader-blink" width="64px" />
                 </div>
            )
        } else if (this.state.countryBlocked) {
            return (
                <div className={"container"}>
                    {this.getMetaHelmet()}
                    <div className={"row"}>
                        <div className={"col-md-6 error-loading-game"}>
                            <div className={"alert alert-warning"}>{t("casino.country-blocked")}</div>
                            <a className={"btn btn-primary"} onClick={()=> this.close() }>{t("casino.back-to-lobby")}</a>
                        </div>
                    </div>
                </div>
            )
        } else if(this.state.bonusBlocked) {
            return (
                <div className={"container"}>
                    {this.getMetaHelmet()}
                    <div className={"row"}>
                        <div className={"col-md-6 error-loading-game"}>
                            <div className={"alert alert-warning"}>{t("casino.bonus-blocked")}</div>
                            <a className={"btn btn-primary"} onClick={()=> this.close() }>{t("casino.back-to-lobby")}</a>
                        </div>
                    </div>
                </div>
            )
        } else if(this.state.kycBlocked) {
            return (
                <div className={"container"}>
                    {this.getMetaHelmet()}
                    <div className={"row"}>
                        <div className={"col-md-6 error-loading-game"}>
                            <div className={"alert alert-warning"}>{t("casino.kyc-blocked")}</div>
                            <ProfileMetamapComponent />
                        </div>
                    </div>
                </div>
            )
        } else if(this.state.currencyNotSupported) {
            return (
                <div className={"container"}>
                    {this.getMetaHelmet()}
                    <div className={"row"}>
                        <div className={"col-md-6 error-loading-game"}>
                            <div className={"alert alert-warning"}>{t("casino.currency-not-supported")}</div>
                            <a className={"btn btn-primary"} onClick={()=> this.close() }>{t("casino.back-to-lobby")}</a>
                        </div>
                    </div>
                </div>
            )
        } else if(this.state.status == LaunchUrlStatus.ERROR || (!this.props.game && this.props.status == CasinoStatus.DONE)) {
            return (
                <div className={"container"}>
                    {this.getMetaHelmet()}
                    <div className={"row"}>
                        <div className={"col-md-6 error-loading-game"}>
                            <div className={"alert alert-warning"}>{t("casino.failed-to-load-game")}</div>
                            <a className={"btn btn-primary"} onClick={()=> this.close() }>{t("casino.back-to-lobby")}</a>
                        </div>
                    </div>
                </div>
            )
        } else if(this.getGameMode() == GameMode.LOGIN_TO_PLAY_FOR_REAL) {
            return (
                <div className={"main-container"} id={"pageContainer"}>
                    {this.getMetaHelmet()}
                    <div className={"container login-to-play-container"}>
                        {this.props.isMobile && (
                            <div onClick={() => this.close()} className="game-close-mobile">
                                <CloseButton />
                            </div>
                        )}
                        <div className={"row casino-game-login-row"}>
                            {this.props.game && <CasinoGameThumbnail compact={false} game={this.props.game} updateSearchValue={()=>{}} loggedIn={false} favourite={false} toggleFavourite={()=>{}}/>}
                        </div>
                        <div className={"row games-list casino-game-login-row"}>
                            <div className={"casino-game-login"}>
                                <h1 className={`title`}>
                                    {
                                        this.props.game?.name &&
                                        <Translator defaultTranslation={this.props.game.name} translations={(this.props.game.translations ?? []).map(t=>({lng : t.language, value : t.name})) as any} />
                                    }
                                </h1>
                                { this.props.game?.description && <p className={"game-description"}><Translator defaultTranslation={this.props.game?.description} translations={(this.props.game?.translations ?? []).map(t=>({lng : t.language, value : t.description})) as any} /></p>}
                                <p>{t("casino.login-or-register")}</p>
                                <button  onClick={()=> {setModalPath({path: {type: PATH.LOGIN, modal: PATH.MODAL_TYPE}, history: this.props.history, options: this.props.userModal })}} className={"btn btn-cta full-width"}>{t("casino.category.logInToPlay")}</button>
                                <a onClick={() => this.close()} className={"btn btn-primary back-to-lobby"}>{t("casino.back-to-lobby")}</a>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }

        if(!this.state.gameUrl) {
            return <div/>
        }
       
        if(!this.props.game) {
            return  <div/>;
        }



         return(<div >
               {this.getMetaHelmet()}
          <BlinkCasinoGameComponent launchUrl={this.state.gameUrl} />
        
       </div>)
          
        
    }

}


const dispatchToProps = (dispatch : Dispatch) => (
    {
        loadCasinoGames : ()=> dispatch(loadCasinoGames() as any),
        hideSideMenu : () => dispatch(showSideMenu(false)),
        setShowBalance : (show: boolean)=> dispatch(setShowBalance(show) as any),
        addPlayedGame : (game : CasinoGameInfo, pageId?: number) => dispatch(addPlayedGame(game, pageId) as any),
        toggleFavourite : (game? : CasinoGameInfo, pageId? : number) => game && dispatch(toggleFavouriteGame(game,pageId) as any),
    }
);
const mapStateToProps = (app : AppState, props : Props) => {
    let currency = app.user.activeCurrency ?? "";
    let balances = app.user.balances;
    if(!currency && balances && balances.length > 0) {
        if(balances[0].balance && balances[0].balance.currencyCode) {
            currency = balances[0].balance.currencyCode;
        }
    }
    let gameId = props.match.params.gameId;
    let game = app.casino.lobby?.games?.[gameId];
    let isFavourite : boolean = !!getFavouritesBySelectedPage(app).find((g : CasinoGameInfo) => g.id == gameId);

    return {
        status : app.casino.status,
        game : game,
        userModal: app.user.modal,
        gameId : gameId,
        currencyCode :currency,
        windowSize: app.settings.windowSize,
        searchValue: app.casino.searchValue,
        favourite : isFavourite,
        settings : app.settings.settings,
        loggedIn : app.user.user && app.user.user.loggedIn,
        studios : getStudios(app),
        selectedTab : getSelectedPageTab(app),
        selectedPage : getSelectedPage(app),
        currencyDefinition : getCurrencyDefinitionByCode(app, currency),
        showBalance : app.user.showBalance,
        isMobile: app.settings.mobile
    }
};


export default connect(mapStateToProps, dispatchToProps)(withRouter<AllProps,any>(BlinkCasinoGameView) as any)



